<div class="app-content">
  <dangl-header
    prefix="Dangl"
    postfix=".AVACloud Admin"
    [preReleaseVersion]="preReleaseVersion()"
    [preReleaseBuildDate]="preReleaseBuildDate()"
    [preReleaseLiveSiteLink]="preReleaseLiveSiteLink()"
    (menuButtonClicked)="toggleMenuButton()"
    [showMenuButton]="isAuthenticated()"
    >
    @if (isAuthenticated()) {
      @if (userIdenticonId) {
        <img class="profile-image" [diIcon]="userIdenticonId | async" [rectangleSize]="30" />
      }
      <span class="username">&nbsp;{{ username | async }}</span>
      <button class="desktop-button" mat-flat-button color="primary" (click)="logout()">
        <mat-icon class="logout-icon">power_settings_new</mat-icon>
        <span i18n>Logout</span>
      </button>
    }
  </dangl-header>
  <mat-sidenav-container>
    <mat-sidenav [mode]="sideNavMode" [opened]="menuOpened()" (closedStart)="menuOpened.set(false)">
      <da-sidenav></da-sidenav>
    </mat-sidenav>
    <mat-sidenav-content class="app-flex-parent">
      <div [class.main-content]="isAuthenticated()" class="app-flex-view">
        <router-outlet> </router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <dangl-footer [showLegalNotice]="false"></dangl-footer>
</div>
